module.exports = __webpack_public_path__ + "img/Feature.69d2b9c8.jpg";